module.exports = __webpack_public_path__ + "img/Wigo_icons_redesign_shield_check.a264d9c0.svg";